<template>
  <div class="px-6 py-6 space-y-6 min-h-screen transition-colors duration-200 text-left select-none"
    :class="isDark ? 'bg-zinc-950 text-zinc-400' : 'bg-zinc-50 text-zinc-600'">
    
    <!-- Header -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b pb-5 gap-4"
      :class="isDark ? 'border-zinc-900' : 'border-zinc-200'">
      <div class="space-y-1">
        <h1 class="text-xl font-medium tracking-tight" :class="isDark ? 'text-white' : 'text-zinc-900'">
          // {{ isEditMode ? 'Modifier un Collaborateur' : 'Enrôler un Collaborateur' }}
        </h1>
        <p class="text-xs">Matrice d'identité, assignation des compétences par services et configuration des cycles horaires.</p>
      </div>
      <div class="flex items-center gap-3">
        <button @click="resetForm" class="px-4 py-2 rounded-xl text-xs font-semibold uppercase tracking-wider border transition-colors cursor-pointer"
          :class="isDark ? 'bg-zinc-900 hover:bg-zinc-800 border-zinc-800' : 'bg-white border-zinc-200'">Réinitialiser</button>
        <button @click="submitEmployee" class="px-5 py-2 rounded-xl text-xs font-semibold uppercase tracking-wider shadow-lg transition-all cursor-pointer"
          :class="isDark ? 'bg-white hover:bg-zinc-200 text-black' : 'bg-zinc-900 hover:bg-zinc-800 text-white'">
          {{ isEditMode ? 'Modifier le profil' : 'Créer le profil matricule' }}
        </button>
      </div>
    </div>

    <div class="max-w-4xl space-y-6">
      
      <!-- 01 Identité -->
      <div class="border rounded-xl overflow-hidden" :class="isDark ? 'border-zinc-900 bg-zinc-900/40' : 'border-zinc-200 bg-white'">
        <button @click="toggleSection('identity')" class="w-full flex justify-between px-5 py-4 text-xs uppercase tracking-wider font-semibold border-b transition-colors"
          :class="isDark ? 'bg-zinc-900/80 border-zinc-900 text-zinc-300' : 'bg-zinc-50 border-zinc-200'">
          <span>01 / Identité & Design Agenda</span>
          <span :class="{'rotate-180': sections.identity}">▼</span>
        </button>
        <div v-show="sections.identity" class="p-6 grid md:grid-cols-2 gap-6">
          <div class="space-y-1"><label class="text-[9px] uppercase font-bold">Prénom & Nom</label><input v-model="form.name" class="w-full px-4 py-2.5 rounded-lg border text-xs" :class="isDark ? 'bg-zinc-950 border-zinc-800' : 'bg-white border-zinc-200'" /></div>
          <div class="space-y-1"><label class="text-[9px] uppercase font-bold">Rôle</label><select v-model="form.role" class="w-full px-4 py-2.5 rounded-lg border text-xs" :class="isDark ? 'bg-zinc-950 border-zinc-800' : 'bg-white border-zinc-200'"><option value="admin">Admin (Accès complet)</option><option value="collaborateur">Collaborateur (Accès limité)</option></select></div>
          <div class="space-y-1"><label class="text-[9px] uppercase font-bold">Spécialité</label><input v-model="form.specialite" placeholder="Ex: Master Barber, Coloriste Expert..." class="w-full px-4 py-2.5 rounded-lg border text-xs" :class="isDark ? 'bg-zinc-950 border-zinc-800' : 'bg-white border-zinc-200'" /></div>
          <div class="space-y-1"><label class="text-[9px] uppercase font-bold">Email</label><input v-model="form.email" class="w-full px-4 py-2.5 rounded-lg border text-xs" :class="isDark ? 'bg-zinc-950 border-zinc-800' : 'bg-white border-zinc-200'" /></div>
          <div class="space-y-1" v-if="!isEditMode"><label class="text-[9px] uppercase font-bold">Mot de passe</label><input type="password" v-model="form.password" class="w-full px-4 py-2.5 rounded-lg border text-xs" :class="isDark ? 'bg-zinc-950 border-zinc-800' : 'bg-white border-zinc-200'" /></div> 
        </div>
      </div>

      <!-- 02 Compétences -->
      <div class="border rounded-xl overflow-hidden" :class="isDark ? 'border-zinc-900 bg-zinc-900/40' : 'border-zinc-200 bg-white'">
        <button @click="toggleSection('skills')" class="w-full flex justify-between px-5 py-4 text-xs uppercase tracking-wider font-semibold border-b"
          :class="isDark ? 'bg-zinc-900/80 border-zinc-900 text-zinc-300' : 'bg-zinc-50 border-zinc-200'">
          <span>02 / Spécialités & Arborescence des Compétences</span>
          <span :class="{'rotate-180': sections.skills}">▼</span>
        </button>
        <div v-show="sections.skills" class="p-6 space-y-6">
          <div v-for="category in serviceStructure" :key="category.id" class="border rounded-xl p-4" :class="isDark ? 'border-zinc-800 bg-zinc-950/50' : 'border-zinc-200'">
            <div class="flex justify-between items-center mb-4">
              <label class="font-bold text-xs uppercase flex items-center gap-2"><input type="checkbox" @change="toggleCategoryGroup(category)" :checked="isCategoryFullySelected(category)" /> 📁 {{ category.name }}</label>
              <span class="text-[9px] bg-zinc-800 px-2 py-0.5 rounded">{{ getSelectedCountInCategory(category) }} / {{ category.services.length }} Actes</span>
            </div>
            <div class="grid sm:grid-cols-3 gap-3">
              <div v-for="service in category.services" :key="service.id" @click="toggleServiceSkill(service.id)"
                class="p-3 border rounded-lg cursor-pointer flex justify-between items-center"
                :class="form.skills.includes(service.id) ? (isDark ? 'border-zinc-600 bg-zinc-900' : 'border-zinc-400 bg-zinc-100') : (isDark ? 'border-zinc-800' : 'border-zinc-200')">
                <div>
                  <p class="text-xs font-semibold">{{ service.name }}</p>
                  <p class="text-[9px] opacity-70">{{ service.duration }} min • {{ service.price }}€</p>
                </div>
                <input type="checkbox" :checked="form.skills.includes(service.id)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 03 Permissions & Accès Modules (Collaborateur uniquement) -->
      <div v-if="form.role === 'collaborateur'" class="border rounded-xl overflow-hidden" :class="isDark ? 'border-zinc-900 bg-zinc-900/40' : 'border-zinc-200 bg-white'">
        <button @click="toggleSection('permissions')" class="w-full flex justify-between px-5 py-4 text-xs uppercase tracking-wider font-semibold border-b"
          :class="isDark ? 'bg-zinc-900/80 border-zinc-900 text-zinc-300' : 'bg-zinc-50 border-zinc-200'">
          <span>03 / Permissions & Accès aux Modules</span>
          <span :class="{'rotate-180': sections.permissions}">▼</span>
        </button>
        <div v-show="sections.permissions" class="p-6 space-y-4">
          <p class="text-xs text-amber-500 mb-4"><i class="fas fa-info-circle mr-1"></i> Les administrateurs ont automatiquement accès à tous les modules. Définissez ici les accès spécifiques pour les collaborateurs.</p>

          <div class="grid sm:grid-cols-2 gap-4">
            <label v-for="(value, key) in form.permissions" :key="key" class="flex items-center gap-3 p-3 border rounded-lg cursor-pointer transition-all"
              :class="form.permissions[key] ? (isDark ? 'border-emerald-600 bg-emerald-950/30' : 'border-emerald-400 bg-emerald-50') : (isDark ? 'border-zinc-800 bg-zinc-950' : 'border-zinc-200 bg-white')">
              <input type="checkbox" v-model="form.permissions[key]" class="w-4 h-4 rounded text-emerald-600 focus:ring-emerald-500" />
              <div class="flex-1">
                <p class="text-xs font-semibold" :class="isDark ? 'text-white' : 'text-zinc-900'">{{ getPermissionLabel(key) }}</p>
                <p class="text-[10px]" :class="isDark ? 'text-zinc-500' : 'text-zinc-500'">{{ getPermissionDescription(key) }}</p>
              </div>
            </label>
          </div>

          <div class="flex gap-2 pt-4 border-t" :class="isDark ? 'border-zinc-800' : 'border-zinc-200'">
            <button @click="selectAllPermissions" class="px-4 py-2 rounded-lg text-xs font-semibold transition-colors" :class="isDark ? 'bg-zinc-900 hover:bg-zinc-800 text-zinc-300' : 'bg-zinc-100 hover:bg-zinc-200 text-zinc-700'">
              Tout sélectionner
            </button>
            <button @click="deselectAllPermissions" class="px-4 py-2 rounded-lg text-xs font-semibold transition-colors" :class="isDark ? 'bg-zinc-900 hover:bg-zinc-800 text-zinc-300' : 'bg-zinc-100 hover:bg-zinc-200 text-zinc-700'">
              Tout désélectionner
            </button>
          </div>
        </div>
      </div>

      <!-- 04 Horaires -->
      <div class="border rounded-xl overflow-hidden" :class="isDark ? 'border-zinc-900 bg-zinc-900/40' : 'border-zinc-200 bg-white'">
        <button @click="toggleSection('hours')" class="w-full flex justify-between px-5 py-4 text-xs uppercase tracking-wider font-semibold border-b"
          :class="isDark ? 'bg-zinc-900/80 border-zinc-900 text-zinc-300' : 'bg-zinc-50 border-zinc-200'">
          <span>04 / Configuration des Horaires de Ligne</span>
          <span :class="{'rotate-180': sections.hours}">▼</span>
        </button>
        <div v-show="sections.hours" class="p-6 space-y-3">
          <div v-for="day in form.timetable" :key="day.dayName" class="grid sm:grid-cols-4 gap-4 p-3 border rounded-lg items-center"
            :class="[isDark ? 'border-zinc-800 bg-zinc-950' : 'border-zinc-200', !day.active && 'opacity-60']">
            <label class="text-xs font-bold uppercase flex items-center gap-2"><input type="checkbox" v-model="day.active" /> {{ day.dayName }}</label>
            <input type="time" v-model="day.start" :disabled="!day.active" class="px-2 py-1 border rounded text-xs" :class="isDark ? 'bg-zinc-900 border-zinc-800' : 'bg-white'" />
            <input type="time" v-model="day.end" :disabled="!day.active" class="px-2 py-1 border rounded text-xs" :class="isDark ? 'bg-zinc-900 border-zinc-800' : 'bg-white'" />
            <span class="text-right text-[9px] uppercase font-bold" :class="day.active ? 'text-emerald-500' : 'text-zinc-500'">{{ day.active ? 'Poste Ouvert' : 'Repos' }}</span>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { toast } from 'vue3-toastify'
import api from '@/api'
import { useTheme } from '@/composables/useTheme';

// Variable globale injectée ou reçue par props pour basculer de thème
const { isDark } = useTheme();
const router = useRouter()
const route = useRoute()

// Edit mode detection
const isEditMode = ref(false)
const editId = ref(null)

// Section Accordion Visibility Controls
const sections = reactive({
  identity: true,
  skills: false,
  permissions: false,
  hours: false,
  sync: false
})

const toggleSection = (key) => {
  sections[key] = !sections[key]
}


// Service structure from backend
const serviceStructure = ref([])

// Fetch services and categories from backend
const fetchServicesAndCategories = async () => {
  try {
    const [categoriesResponse, servicesResponse] = await Promise.all([
      api.services.getAllCategories(),
      api.services.getAllServices()
    ])

    // Backend retourne des formats différents:
    // - Catégories: { success: true, message: '...', categories: [...] }
    // - Services: directement le tableau [...]
    const categories = categoriesResponse.data?.categories || categoriesResponse.data || []
    const services = Array.isArray(servicesResponse.data) ? servicesResponse.data : []

    serviceStructure.value = categories.map(cat => ({
      id: cat._id,
      name: cat.nom,
      services: services
        .filter(srv => srv.categorie?._id === cat._id)
        .map(srv => ({
          id: srv._id,
          name: srv.nom,
          duration: srv.duree || 30,
          price: srv.prix || 0
        }))
    }))
  } catch (error) {
    console.error('Erreur lors du chargement des services', error)
    toast.error('Erreur lors du chargement des services')
  }
}

// Load staff data for edit mode
const loadStaffData = async (id) => {
  try {
    const response = await api.staff.getStaffById(id)
    const staff = response.data

    // Populate form with staff data
    form.name = staff.nom || ''
    form.email = staff.email || ''
    form.role = staff.role || 'collaborateur'
    form.specialite = staff.specialite || ''
    form.color = staff.couleur || '#e4e4e7'

    // Charger les compétences (services_qualifies peut être un tableau d'IDs ou d'objets)
    if (staff.services_qualifies && Array.isArray(staff.services_qualifies)) {
      form.skills = staff.services_qualifies.map(s =>
        typeof s === 'string' ? s : (s._id || s.id)
      )
    } else {
      form.skills = []
    }

    console.log('✅ Compétences chargées:', form.skills)

    form.isGoogleConnected = staff.googleCalendarConnected || false
    form.googleCalendarId = staff.googleCalendarId || 'primary'
    form.syncFrequency = staff.syncFrequency || 'realtime'

    // Load permissions if they exist
    if (staff.permissions) {
      Object.keys(form.permissions).forEach(key => {
        if (staff.permissions[key] !== undefined) {
          form.permissions[key] = staff.permissions[key]
        }
      })
    }

    // Map horaires to timetable
    if (staff.horaires) {


      form.timetable.forEach(day => {
        const dayKey = day.dayName.toLowerCase()
        const horaireData = staff.horaires[dayKey]

        if (horaireData) {
          day.active = horaireData.ouvert !== false
          day.start = horaireData.debut || '09:00'
          day.end = horaireData.fin || '18:00'
        }
      })
    }

    toast.success('Données chargées')
  } catch (error) {
    console.error('Erreur lors du chargement du collaborateur', error)
    toast.error('Erreur lors du chargement des données')
  }
}

// Load data on mount
onMounted(async () => {
  await fetchServicesAndCategories()

  // Check for edit mode
  if (route.query.edit) {
    isEditMode.value = true
    editId.value = route.query.edit
    await loadStaffData(editId.value)
  }
})

// Master Sub-Form State
const form = reactive({
  name: '',
  role: 'collaborateur', // Par défaut collaborateur
  specialite: '', // Nouvelle spécialité distincte du rôle
  email: '',
  password: '',
  color: '#e4e4e7',
  skills: [], // Array holding active unique service IDs
  permissions: {
    caisse: false,
    prestations: false,
    categories: false,
    services: false,
    clients: false,
    planning: false,
    statistiques: false,
    parametres: false,
    promotions: false,
    fidelite: false,
    collaborateurs: false
  },
  timetable: [
    { dayName: 'Lundi', active: true, start: '09:00', end: '18:00' },
    { dayName: 'Mardi', active: true, start: '09:00', end: '18:00' },
    { dayName: 'Mercredi', active: true, start: '09:00', end: '18:00' },
    { dayName: 'Jeudi', active: true, start: '09:00', end: '19:00' },
    { dayName: 'Vendredi', active: true, start: '09:00', end: '20:00' },
    { dayName: 'Samedi', active: true, start: '08:30', end: '17:00' },
    { dayName: 'Dimanche', active: false, start: '00:00', end: '00:00' }
  ],
  isGoogleConnected: false,
  googleCalendarId: 'primary',
  syncFrequency: 'realtime'
})

// Helper functions for permissions
const getPermissionLabel = (key) => {
  const labels = {
    caisse: 'Caisse',
    prestations: 'Prestations',
    categories: 'Catégories',
    services: 'Services',
    clients: 'Clients',
    planning: 'Planning',
    statistiques: 'Statistiques',
    parametres: 'Paramètres',
    promotions: 'Promotions',
    fidelite: 'Fidélité',
    collaborateurs: 'Collaborateurs'
  }
  return labels[key] || key
}

const getPermissionDescription = (key) => {
  const descriptions = {
    caisse: 'Accès à la caisse et transactions',
    prestations: 'Gérer les rendez-vous et prestations',
    categories: 'Gérer les catégories de services',
    services: 'Créer et modifier les services',
    clients: 'Gérer la base clients',
    planning: 'Voir et gérer le planning',
    statistiques: 'Consulter les statistiques',
    parametres: 'Modifier les paramètres du salon',
    promotions: 'Gérer les promotions',
    fidelite: 'Gérer le programme de fidélité',
    collaborateurs: 'Gérer les autres collaborateurs'
  }
  return descriptions[key] || ''
}

const selectAllPermissions = () => {
  Object.keys(form.permissions).forEach(key => {
    form.permissions[key] = true
  })
}

const deselectAllPermissions = () => {
  Object.keys(form.permissions).forEach(key => {
    form.permissions[key] = false
  })
}

/* =========================================================================
   COMPETENCE MATRIX LOGIC (BY SERVICES OR WHOLE CATEGORY BUNDLES)
   ========================================================================= */

// Single unique service switch
const toggleServiceSkill = (id) => {
  const index = form.skills.indexOf(id)
  if (index > -1) form.skills.splice(index, 1)
  else form.skills.push(id)
}

// Check if entire category items are inside active tracking skills field
const isCategoryFullySelected = (category) => {
  return category.services.every(srv => form.skills.includes(srv.id))
}

// Intermediate structural layout check for checkboxes


const getSelectedCountInCategory = (category) => {
  return category.services.filter(srv => form.skills.includes(srv.id)).length
}

// Checkbox action triggered at Category cluster node level
const toggleCategoryGroup = (category) => {
  if (isCategoryFullySelected(category)) {
    // Purge all services belonging to this category
    category.services.forEach(srv => {
      const idx = form.skills.indexOf(srv.id)
      if (idx > -1) form.skills.splice(idx, 1)
    })
  } else {
    // Inject all missing services belonging to this category
    category.services.forEach(srv => {
      if (!form.skills.includes(srv.id)) {
        form.skills.push(srv.id)
      }
    })
  }
}

/* =========================================================================
   GENERIC MUTATION SYSTEM PIPELINES
   ========================================================================= */


const resetForm = () => {
  form.name = ''
  form.email = ''
  form.password = ''
  form.color = '#e4e4e7'
  form.skills = []
  form.timetable.forEach(day => {
    day.active = day.dayName !== 'Dimanche'
    day.start = '09:00'
    day.end = '18:00'
  })
  form.isGoogleConnected = false
}

const submitEmployee = async () => {
  if (!form.name || !form.email) {
    toast.error('Identité incomplète : nom et email requis', { position: 'top-right' })
    return
  }

  if (!isEditMode.value && !form.password) {
    toast.error('Mot de passe requis pour la création', { position: 'top-right' })
    return
  }

  try {
    // Prepare payload for backend
    const payload = {
      nom: form.name,
      prenom: form.name,
      email: form.email,
      role: form.role, // 'admin' ou 'collaborateur'
      specialite: form.specialite, // Spécialité distincte
      couleur: form.color,
      services_qualifies: form.skills, // Utiliser le bon nom de champ
      permissions: form.role === 'collaborateur' ? form.permissions : undefined, // Envoyer permissions seulement pour collaborateurs
      horaires: form.timetable.reduce((acc, day) => {
        acc[day.dayName.toLowerCase()] = day.active ? [
          {
            debut: day.start,
            fin: day.end
          }
        ] : []
        return acc
      }, {}),
      googleCalendarConnected: form.isGoogleConnected,
      googleCalendarId: form.googleCalendarId,
      syncFrequency: form.syncFrequency,
      statut: 'actif'
    }

    console.log('📤 Payload envoyé:', payload)

    if (isEditMode.value) {
      // Update existing staff
      await api.staff.updateStaff(editId.value, payload)
      toast.success(`Collaborateur ${form.name} modifié avec succès !`, { position: 'top-right' })
    } else {
      // Create new staff - add password
      payload.mot_de_passe = form.password
      await api.staff.createStaff(payload)
      toast.success(`Collaborateur ${form.name} créé avec succès !`, { position: 'top-right' })
    }

    setTimeout(() => {
      router.push('/staff')
    }, 500)
  } catch (error) {
    console.error('Erreur lors de la soumission', error)
    toast.error(isEditMode.value ? 'Erreur lors de la modification' : 'Erreur lors de la création', { position: 'top-right' })
  }
}
</script>